export const fillapplicationEn = {
    qsrxgxx:"Please enter relevant information",
    fjxz:"Download the attachment",
    jcxxx:"Detection item information",
    qtzl:"Other information:",
    dqjcxjg:"Price of selected test items:",
    qrbtj:"Confirm and submit"
}


// WEBPACK FOOTER //
// ./src/lang/home/selfHelpFillapplication/indexEn.js